import { Component, EventEmitter, Input, Output, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertsService } from 'src/app/home/services/alerts.service';
import { HomeService } from 'src/app/home/services/home.service';

@Component({
  selector: 'app-close-alert',
  templateUrl: './close-alert.component.html',
  styleUrls: ['./close-alert.component.scss', '../../../../app.component.scss']
})
export class CloseAlertComponent implements OnInit {

  @Input() cabinetName: string;
  @Input() productName: string;
  @Input() status: string;
  @Input() count: number;
  @Input() cabinetId: number;

  @Output() closeClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelClicked: EventEmitter<void> = new EventEmitter<void>();

  public alerts :any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public homeService: HomeService,
    public alertsService: AlertsService,
    public dialogRef: MatDialogRef<CloseAlertComponent>
  ) {
    this.cabinetName = data.cabinet_name;
    this.productName = data.product_name;
    this.status = data.status;
    this.count = data.count;
    this.cabinetId = data.cabinet_id;
  }

  ngOnInit(): void {
    this.getalerts();
  }

  confirmClose() {
    this.dialogRef.close('confirm');
  }

  cancel() {
    this.dialogRef.close('cancel');
  }

  getalerts() {
    this.alertsService.getalerts().subscribe((res) => {
      if (res.data) {
        this.alerts = res.data.data;
      }
    });
  }

  // getAlertsForCabinet(cabinetName: string): any[] {
  //   return this.alerts.filter(alert => alert.cabinet_name === cabinetName);
  // }

  // getCabinetNames(): string[] {
  //   return this.alerts.map(alert => alert.cabinet_name).filter((value, index, self) => self.indexOf(value) === index);
  // }

  getAlertsForCabinet(cabinetName: string): any[] {
    return this.alerts.filter(alert => alert.cabinet_name === cabinetName);
  }

  getAlertsForProducts(productName: string): any[] {
    return this.alerts.filter(alert => alert.product_name === productName);
  }
  
  // getCabinetNames(): string[] {
  //   return this.alerts.map(alert => alert.cabinet_name).filter((value, index, self) => self.indexOf(value) === index);
  // }

  // getProductNames(): string[] {
  //   return this.alerts.map(alert => alert.product_name).filter((value, index, self) => self.indexOf(value) === index);
  // }
  
}

